export default __webpack_public_path__ + "static/media/activeBox.9a7150f7.svg";